import React from 'react';

export default (filtersCollection, tab) => {
  const typeSubtext = () => {
    const apartmentText = filtersCollection[tab].apartment ? 'Appartement' : ''
    const houseText = filtersCollection[tab].house ? 'Maison' : ''
    return subtextHTML(apartmentText, houseText)
  }

  const roomSubtext = () => {
    const minRoomText = `${filtersCollection[tab].min_room_number} ${filtersCollection[tab].min_room_number !== '' ? `Pièce${Number(filtersCollection[tab].min_room_number > 1) ? 's' : '' } min.` : ''}`
    const minBedroomText = `${filtersCollection[tab].min_bedroom_number} ${filtersCollection[tab].min_bedroom_number !== '' ? `Chambre${Number(filtersCollection[tab].min_bedroom_number > 1) ? 's' : '' } min.` : ''}`
    return subtextHTML(minRoomText, minBedroomText)
  }

  const surfaceSubtext = () => {
    const minSurface = `${filtersCollection[tab].min_area} ${filtersCollection[tab].min_area !== '' ? 'm² min.' : ''}`
    const maxSurface = `${filtersCollection[tab].max_area} ${filtersCollection[tab].max_area !== '' ? 'm² max.' : ''}`
    return subtextHTML(minSurface, maxSurface)
  }

  const budgetSubtext = () => {
    const minBudget = `${filtersCollection[tab].min_budget} ${filtersCollection[tab].min_budget !== '' ? '€ min.' : ''}`
    const maxBudget = `${filtersCollection[tab].max_budget} ${filtersCollection[tab].max_budget !== '' ? '€ max.' : ''}`
    return subtextHTML(minBudget, maxBudget)
  }

  const subtextHTML = (value1, value2) => {
    return <div>
      <div className='typo-caption vesta-text-ellipsis'>{value1}</div>
      <div className='typo-caption vesta-text-ellipsis'>{value2}</div>
    </div>
  }

  const moreCriteriaSubtext = () => {
    const moreCriterias = []
    filtersCollection.more_criteria.filter((criteria) => {
      switch (criteria) {
        case 'display_for_sale':
          return moreCriterias.push('Biens en vente');
        case 'with_cellar':
          return moreCriterias.push('Cave');
        case 'with_elevator':
          return moreCriterias.push('Ascenseur');
        case 'with_parking':
          return moreCriterias.push('Parking');
        case 'hide_ground_floor':
          return moreCriterias.push('Pas de RDC');
        case 'with_outsides':
          return moreCriterias.push('Espaces extérieurs');
        case 'display_sold':
          return moreCriterias.push('Biens vendus');
        default:
          break;
      }
    })
    return moreCriterias.join(', ')
  }

  switch (tab) {
    case 'type':
      return typeSubtext();
    case 'budget':
      return budgetSubtext();
    case 'surface':
      return surfaceSubtext();
    case 'room':
      return roomSubtext();
    case 'moreCriteria':
      return moreCriteriaSubtext();
    default:
      break;
  }
}
